<template>

  <div class="requisicao-lancamento ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="4">
                <label for="select-empresa-cor">Empresa</label> 
                <multiselect  id="selecao-empresa-cor"  v-model="value_empresaf" required                  
                  :options="empresasf" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true" 
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="empresa" track-by="empresa" name="empresa"
              >                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="3">
                <label for="select-filial_cor">Filial</label> 
                <multiselect id="selecao-filial-cor"  v-model="value_filial" required                   
                  :options="filiaisf" 
                  :multiple="true"                                    
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  @close="loadSolicitacoes()" 



                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>

<!--
              <b-col cols="2">
                <label for="select-garagem">Status</label>   
                <multiselect  v-model="value_status" required 
                  :options="statuss" 
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a status" label="status" track-by="status" name="status"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Status selecionado</span></template>
                </multiselect> 
              </b-col>
-->


              <b-col cols="4"  class="mb-0">
                <label  for="input-busca">Pesquisa no grid</label> 
                <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Carro / Requisição / Solicitante "></b-form-input>              
              </b-col>      

<!--
              <b-col cols="1"  class="mt-4 ml-2">
                <b-button variant="warning" class="ml-5 mt-2" @click="novo(),loadNovoNrorequisicao(),loadTipos()"  v-b-modal.modal-multi-requisicao  >Novo</b-button>
              </b-col>
-->
          </b-row>






      <b-row>

        <b-col>
          <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>
          
              <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="QUANTIDADE REQUISIÇÕES"
                header-bg-variant="primary"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                   {{ itemsFiltered.length }} 
                  </h2>
                </b-card-text>
              </b-card>
        


      
            <b-card                  
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="QUANTIDADE DE CARRO(s)"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  
                                   {{
                    itemsFiltered.map( sal => sal.carro ).filter((valor, indice, self) => self.indexOf(valor) === indice).length
                                
                            }} 
                </h2>
                
              </b-card-text>
      </b-card>        

      </b-card-group> 
        </b-col>

          
      

      </b-row>

    </b-form>

    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
    <b-table id="tbldefeitos"  small hover striped sticky-header="660px"  :items="itemsFiltered" :fields="solicitacoesCabecalho" >    
        <template slot="cell(actions)" slot-scope="data"  >

          <b-button @click="editrequisicaoCabecalho(data.item),loadSolicitacoesItens(data.item['solicitacao_id']),loadEmpresaCad(),loadFiliaisCad(), loadVeiculo(), loadSolicitante(),loadLider()" v-b-modal.modal-multi-requisicao title="Acessar solicitação"  size="sm" variant="success" class="mr-2">                
              <i class="fa fa-exclamation-circle"></i>
          </b-button>
          

        </template>   
        
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div >        
        <b-modal id="modal-multi-requisicao"  hide-footer size="xl" centered  title="Cadastro de ficha requisicao "  @close="novo()" no-close-on-esc no-close-on-backdrop  >
              <!-- -->
              <div >

              <!-- EMPRESA FILIAL --> 
                <b-row id="defeito-selecao" >
                    <b-col cols="3">
                    <label for="input-garagem">Empresa</label>  <!-- {{requisicao.id_filial}} -->
                    <div>                
                      <b-form-select   
                        id="garagem"    
                        
                        v-model="solicitacaoItem.empresa_id"                    
                        required                                                   
                        :options="empresas"
                        @change="loadFiliaisCad()"
                        class="mb-3 "
                        text-field="empresa"                                            
                      >                
                      </b-form-select>
                    </div>
                  </b-col>

                  <b-col cols="3">
                    <label for="input-garagem">Filial</label>  <!-- {{requisicao.id_filial}} -->
                    <div>                
                      <b-form-select   
                        id="garagem"    
                        
                        v-model="solicitacaoItem.filial_id"                    
                        required                                                   
                        :options="filiais"                        
                        class="mb-3 "
                        text-field="filial"                                            
                      >                
                      </b-form-select>
                    </div>
                  </b-col>

                  
                <b-col cols="2">
                    <label for="input-live">Data de abertura</label>     
                    <b-input-group-text >{{ solicitacaoItem.dt_solicitacao ? moment(requisicao.dt_solicitacao).format('DD/MM/YYYY HH:mm').replace('Data inválida','-')  : '-'  }}</b-input-group-text>
                </b-col> 



                <b-col cols="2">
                    <label for="input-live">Data de fechamento</label>     
                    <b-input-group-text >{{ solicitacaoItem.dt_encerramento ? moment(requisicao.dt_encerramento).format('DD/MM/YYYY HH:mm').replace('Data inválida','-')  : '-'  }}</b-input-group-text>
                </b-col> 



                <b-col cols="2">
                    <label for="input-live">Nº da requisição</label>     
                    <b-input-group-text >{{nrorequisicao.length > 0 ? nrorequisicao : (solicitacaoItem.solicitacao_id >0 ? solicitacaoItem.solicitacao_id   : '-')  }}</b-input-group-text>
                </b-col> 






                </b-row>
                
                  <!-- seleção --> 
                <b-row id="defeito-selecao" >

                  <b-col cols="2"  class="mb-3">
                    <label for="input-live">Carro</label>   
                    <b-form-input v-model="solicitacaoItem.carro" @keyup.enter="loadVeiculo()" required="required" placeholder="Nro carro"></b-form-input>              
                  </b-col> 

                  <b-col cols="2">
                    <label for="input-live">Placa  </label>                
                    <b-input-group-text >{{ veiculos ? veiculos.map(at => at.placa).join(', ') : '-' }}</b-input-group-text>
                  </b-col> 


                <b-col cols="2" >
                    <label for="input-live">Nro O.S</label> 
                    <b-input-group-text >{{ solicitacaoItem.ficha ? solicitacaoItem.ficha : '-' }}</b-input-group-text>                    
                </b-col> 

                
                  <!--Lider --> 

                                    <!--Almoxarife --> 
                    <b-col cols="1" class="mt-2">
                      <b-img
                        class="mb-2"
                        v-model="operador.foto_url"
                        :src="solicitacaoItem.foto_lider_thumbnail || 'https://ml18cliente.s3.sa-east-1.amazonaws.com/sambaiba/sem-foto.jpg'"
                        rounded
                        alt="-"
                        style="width: 66px; height: 66px;"
                      ></b-img>
                    </b-col>


                  <b-col cols="2" >
                    <label for="input-live">Lider</label> 
                    <b-form-input v-model="solicitacaoItem.encarregado_re" @keyup.enter="loadLider()" required placeholder="RE"></b-form-input>              
                  </b-col> 

                  <b-col cols="3">
                    <label for="input-live">Função  </label>                 
                    <b-input-group-text >{{ lideres.funcao ? lideres['funcao'] : '-' }}</b-input-group-text>
                  </b-col> 








































                              <div class="mb-2">
              
            </div>
                  
                
                </b-row>


                

                <b-row id="id-informado" class="pt-1 pb-1">


                  
                  <!--Solicitante --> 
                  <b-col cols="1" class="mt-2">
                        <b-img
                        class="mb-2"
                        v-model="operador.foto_url"
                        :src="solicitacaoItem.foto_solicitante_thumbnail || 'https://ml18cliente.s3.sa-east-1.amazonaws.com/sambaiba/sem-foto.jpg'"
                        rounded
                        alt="Foto do solicitante"
                        style="width: 66px; height: 66px;"      
                      ></b-img>
                  </b-col>

                  <b-col cols="2" >
                    <label for="input-live">Solicitante</label> 
                    <b-form-input v-model="solicitacaoItem.solicitante_re" @keyup.enter="loadSolicitante()" required placeholder="RE"></b-form-input>              
                  </b-col> 

                  <b-col cols="3">
                    <label for="input-live">Função  </label>                 
                    <b-input-group-text >{{ solicitantes.funcao ? solicitantes['funcao'] : '-' }}</b-input-group-text>
                  </b-col>                 


                  <!--Almoxarife --> 
                  <b-col cols="1" class="mt-2">
                        <b-img
                        class="mb-2"
                        v-model="operador.foto_url"
                        :src="solicitacaoItem.foto_almoxarife_thumbnail || 'https://ml18cliente.s3.sa-east-1.amazonaws.com/sambaiba/sem-foto.jpg'"
                        rounded
                        alt="-"
                        style="width: 66px; height: 66px;"      
                      ></b-img>
                  </b-col>

                  <b-col cols="2" >
                    <label for="input-live">Almoxarife</label> 
                    <b-form-input v-model="solicitacaoItem.almoxarife_re" @keyup.enter="loadAlmoxarife()" required placeholder="RE"></b-form-input>              
                  </b-col> 


                  <b-col cols="3">
                    <label for="input-live">Função</label>                 
                    <b-input-group-text >{{ almoxarifes.funcao ?  almoxarifes['funcao']: '-' }}</b-input-group-text>   <!--   almoxarifes.map(at => at.funcao).join(', ')   -->
                  </b-col> 


                  

                </b-row>

                <b-row id="id-itemsolicitado" class="pt-1 pb-1">
                

                    <!--material               --> 

                  <b-col cols="2" >
                    <label for="input-live">Material</label> 
                    <b-form-input v-model="solicitacaoItem.material" @keyup.enter="loadMaterial()" required placeholder="Código"></b-form-input>              
                  </b-col> 

                  <b-col cols="4">
                    <label for="input-live">Descrição do material  </label>      
                    <b-input-group-text id="material_descricao" >{{ materiais.descricao ? materiais.descricao : '-' }}</b-input-group-text>
                  </b-col> 

                  <b-col cols="3">
                    <label for="input-live">Referencia</label>                
                    <b-input-group-text id="material_referencia" >{{ materiais.referencia ? materiais.referencia : '-' }}</b-input-group-text>
                  </b-col> 

                  <b-col cols="3">
                    <label for="input-live">Descrição do fornecedor</label>                
                    <b-input-group-text id="material_fornecedor">{{ materiais.fornecedor ? materiais.fornecedor : '-' }}</b-input-group-text>
                  </b-col> 
                  
                  
                  


                  <b-col cols="5"  class="mb-0">
                    <label  for="input-live">Observações do solicitante</label> 
                    <b-form-input v-model="solicitacaoItem.observacao" readonly required="required" placeholder="Observações"></b-form-input>              
                  </b-col>

                  <b-col cols="2" >
                    <label for="input-live">Qtd solicitada</label> 
                    <b-form-input v-model="solicitacaoItem.qtd_solicitada" @keyup.enter="loadExecutante()" readonly required placeholder="qtd solicitada"></b-form-input>              
                  </b-col> 


                  <b-col cols="2" >
                    <label for="input-live">Qtd atendida</label> 
                    <b-form-input v-model="solicitacaoItem.qtd_atendida" required placeholder="qtd atendida"></b-form-input>              
                  </b-col> 


                  <b-col cols="3">                                              
                      <b-form-checkbox
                        id="requisicao-causador" 
                        class="mb-0 mt-5 "
                        v-model="solicitacaoItem.venda_perdida"                  
                        name="checkbox-2"
                        value="true"
                        unchecked-value="false"
                        checked="true"
                      >                  
                      Ruptura de estoque 
                      </b-form-checkbox>                
                  </b-col>
                


                </b-row>


                <!-- fechamento -->
                <b-row id="id-encerramento" cols="10" class="mt-2">

                  <b-col cols="2">
                    <label for="input-live">Data Abertura</label>                 
                    <b-input-group-text >{{ solicitacaoItem.dt_abertura ? moment(solicitacaoItem.dt_abertura ).format('DD/MM/YYYY HH:mm').replace('Data inválida','-')  : '-'  }}</b-input-group-text>
                  </b-col> 

                  <b-col cols="2">                
                    <label for="input-live">Data entrega</label>                  
                    <b-input-group-text >{{ solicitacaoItem.dt_entrega ? moment(solicitacaoItem.dt_entrega).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') : '-' }}</b-input-group-text>
                  </b-col> 


                  <b-col cols="2">
                    <label for="input-live">ERP Nro Ficha</label> 
                    <b-form-input v-model="solicitacaoItem.ficha" readonly placeholder="A18562022"></b-form-input>              
                  </b-col> 

                  <b-col cols="2">
                    <label for="input-live">ERP Data importação</label> 
                    <b-input-group-text >{{ solicitacaoItem.dt_jb_acesso ? moment(requisicao.dt_jb_acesso).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') : '-'  }}</b-input-group-text>                
                  </b-col> 

                  <b-col cols="2">
                    <label for="input-live">ERP O.S terceiro</label> 
                    <b-form-input v-model="lin.id_linha_erp"  readonly placeholder="ML28122022">  </b-form-input>              
                  </b-col> 











                  <b-col cols="1" class="mt-2 mb-2"> 
                    <b-button class="mt-4" variant="success"   @click="encerrarCabecalho()">
                      <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Encerrar
                    </b-button>                      
                  </b-col> 

                  

                  <b-col cols="1" class="mt-2 mb-2"> 
                    <b-button class="mt-4" variant="danger"  :disabled="carregando" @click="reset()">                  
                      <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Gravar
                    </b-button>                      
                  </b-col> 

                </b-row>

                <!-- defeitos da requisicao -->
                <b-table id="tbrequisicaodefeitos"  small hover striped sticky-header="520px"  :items="
                    solicitacoeItens" :fields="requisicaoCorpo" >    
                  <template slot="cell(actions)" slot-scope="data"  >
                    <b-button @click="editrequisicaoCorpo(data.item),loadLider(),loadSolicitante(),loadAlmoxarife()" title="Editar Item"  size="sm" variant="success" class="mr-2">                
                      <i class="fa fa-exclamation-circle"></i>
                    </b-button>
                  </template>           
                </b-table>

              </div>          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>  

</template>

<script>
import { baseApiUrl, showError  } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { mapState } from 'vuex' 

export default {

    name: 'ManutencaoRfiLancamento', 
    
    /*
    computed: mapState(['user']),   
    */

    computed : { ... mapState (['user'],),

      itemsFiltered(){
        let valorefu = [];       
        valorefu = this.solicitacoes.filter((item) =>{
          const prefixo = item.carro || ''; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
          const requisitante = item.solicitante_re || '';
          const requisicao = item.id || '';
          //const ordem = item.os_id || '';
          return (
             prefixo.indexOf(this.search) >-1 ||
             requisitante.indexOf(this.search) >-1 ||
             requisicao.indexOf(this.search) >-1 
             //|| ordem.indexOf(this.search) >-1
             
          );
        });
        return valorefu
        }  ,

        itemsFilteredQtd(){
        let valorefu = [];       
        valorefu = this.ResumorequisicaoCorpo.filter((item) =>{
          const prefixo = item.prefixo || ''; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
          const requisitante = item.re_requisitante || '';
          const requisicao = item.requisicao || '';
          //const ordem = item.os_id || '';
          return (
             prefixo.indexOf(this.search) >-1 ||
             requisitante.indexOf(this.search) >-1 ||
             requisicao.indexOf(this.search) >-1 
             //|| ordem.indexOf(this.search) >-1
             
          );
        });
        return valorefu
        }


    } ,


    data: function() {
      
      return {
        
          solicitacoes:[],
          solicitacoeItens:[],
          solicitacaoItem:{},
          requisicoes:[],
          itemrequisicao:{},
          ResumorequisicaoCorpo:[],

          
          executante:{},          //   18/02/2024
          executantes: [],  
          lider:{},
          lideres:[],
          almoxarifes:[],
          almoxarife:{},
          materiais:[],
            empresas:[],
            filiais:[],
            empresasf:[],
            empresaf:{},
            filiaisf:[],
            filialf:{},
            veiculos:[],
            operador:[],            
            socorrista_carro:[],
            trocado_carro:[],
            socorristas:[],
            requisicaos:[],
            requisicao:{},
            viacep:[],

            value_empresaf: [],



            defeitos:[],
            defeito:{},

            gruposi:[],
            subgruposi:[],
            defeitosi:[],
            
            gruposd:[],
            subgruposd:[],
            defeitosd:[],






            mode: 'save',
            carregando: false,
            atualizando: false, 

            
            
            

            
            
            grupo:{},
            grupos:[],
            subgrupo:{},
            subgrupos:[],
            defeito:{},
            defeitos:[],

                        
           // gruposd:[],
            gruposd:{},
            subgrupod:{},
            subgruposd:[],
            defeitod:{},


            solicitante:{},
            solicitantes:[],


            socorrista:{},
            linhas:[],

            nrorequisicao:[],

            
solicitacoeItens:[],
            
            

            statuss:[],
            situacaojb:[],

            value_carro:'',
            value_carro_socorrista:'',
            value_carro_trocado:'',
            value_cep:'',
            value_solicitante:'',
            value_executante:'', 
            value_socorrista:'',           
            value_status:[],
            value_statusjb:[],
            value_tipo:[],
            value_lider:'',
            value_almoxarife:'',
            value_filial:[],
            

            //garagem:{},             
            tipos:[] ,
            search:'',


            

            lin:{},
            
            value_garagem:[],// [] lista                         
            
            
            value_observacoes:'',
           
          //  barra_inicial: 0,         
          //  barra_limite: 300000,
            
            solicitacoesCabecalho: [                    
              { key: 'empresa_id', label: 'Empresa', sortable: true },                 
              { key: 'filial_id', label: 'Filial', sortable: true },                 
              { key: 'dt_lancamento', label: 'Dt_solicitação', sortable: true, formatter: (value, key, solicitacoes) => {
                    return moment(solicitacoes.dt_lancamento).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },                              
              { key: 'solicitacao_id', label: 'Nro Solicitação', sortable: true },  
              { key: 'ficha', label: 'Ficha', sortable: true }, 
              { key: 'carro', label: 'Carro', sortable: true },                     
                { key: 'actions', label: 'Ações' },                
              
            ],


            //////// defeitos da requisicao
            requisicaoCorpo: [                
                { key: 'item', label: 'Id', sortable: true },
                { key: 'solicitacao_id', label: 'Requisição', sortable: true },
                { key: 'ficha', label: 'Nro O.S', sortable: true },                 
                { key: 'material', label: 'Codigo material', sortable: true },
                { key: 'descricao', label: 'Descrição', sortable: true, tdClass: 'col-descricao'  },                                
                { key: 'observacao', label: 'Observação solicitante', sortable: true },                 
                { key: 'qtd_solicitada', label: 'Qtd soliciatada', sortable: true },                                                
                { key: 'qtd_atendida', label: 'Qtd atendida', sortable: true },                                                
                { key: 'venda_perdida', label: 'Venda Perdida', sortable: true,formatter: value => value ? 'Sim' : 'Não'  },                
                { key: 'solicitante_re', label: 'Requisitante', sortable: true },                                                                           
                { key: 'encarregado_re', label: 'Lider', sortable: true },                                                                           
                //{ key: 're_almoxarife', label: 'Almoxarife', sortable: true },                                                                           
                { key: 'dt_solicitacao', label: 'Dt_solicitação', sortable: true, formatter: (value, key, 
solicitacoeItens) => {
                    return moment(
solicitacoeItens.dt_solicitacao).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },                
                { key: 'dt_entrega', label: 'Dt_entrega', sortable: true, formatter: (value, key, 
solicitacoeItens) => {
                    return moment(
solicitacoeItens.dt_entrega).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },                
                { key: 'actions', label: 'Ações' },                
            ]


        }        
    },

    filters: {
      dataFormatada(dt) {
        return dt.substring(0,4)
      }

    },

    components: {
        Multiselect
    },


    methods: {

      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },

      limparFiltro(){
        this.search= ""
      },

         loadEmpresas() {
            let corpo = {    
                "empresa_id": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/jb/controle/empresa`
          axios.post(url,corpo).then(res => {
            this.empresasf = res.data.map(emp => {              
              return { id_empresa: emp.id_empresa, empresa: emp.empresa }
            })
          })
      },  
      
      loadFiliais() {
            let corpo = {    
                "empresa_id":  `${[this.user.id_empresa]}`,                                       
            };
          const url = `${baseApiUrl}/jb/controle/empresa/filial`
          axios.post(url,corpo).then(res => {
            this.filiaisf = res.data.map(filial => {              
              return { filial_id: filial.filial_id, filial: filial.filial }        
            })
          })
      },

      loadEmpresaCad() {
            let corpo = {    
                "empresa_id": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/jb/controle/empresa`
          axios.post(url,corpo)
          .then(res => {this.empresas = res.data.map(emp => {return { ... emp, value: emp.empresa_id, empresa: emp.empresa} })})
          .catch(showError)
      },

      loadFiliaisCad() {
            let corpo = {    
                "empresa_id": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/jb/controle/empresa/filial`
          axios.post(url,corpo)
            .then(res => {
              this.filiais = res.data.map(fil => {                      
                return { ... fil, value: fil.filial_id, filial: fil.filial }  //// para pegar o valor tem que usar o ... atribuicao value
              })
            })
            .catch(showError)
      },
    


    loadSolicitacoes() { 
          let corpo = {    
              "empresa_id":  `${[this.user.id_empresa]}`,                        
              "filial_id": `${[this.value_filial.map(f => f.filial_id)]}`,  
              "origem" : 'WEB' 
          };
          const url = `${baseApiUrl}/jb/estoque/solicitacao/listagem`
          axios.post(url,corpo).then(res => { 
            this.solicitacoes = res.data             
          })
          .catch(showError)         
      },

      loadSolicitacoesItens(solicitacao) { 
          let corpo = {    
              "empresa_id":  `${[this.user.id_empresa]}`,                         
              "solicitacao_id": solicitacao,
              "origem":'EDITARSOLICITACAO'
          };
          const url = `${baseApiUrl}/jb/estoque/solicitacao/listagem`
          axios.post(url,corpo).then(res => { 
            this.solicitacoeItens = res.data             
          })
          .catch(showError)         
      },

      
      loadVeiculo() {
          let corpo = {    
              "empresa_id": `${this.solicitacaoItem.empresa_id}`,
              "carro": `${this.solicitacaoItem.carro}`                 
          };
          const url = `${baseApiUrl}/jb/manutencao/frota/listagem`
          axios.post(url,corpo)                      
          .then(res => { this.veiculos = res.data })                      
          .catch(showError)
        },


      async loadAlmoxarife() { 
            let corpo = {                             
            "registro": `${this.solicitacaoItem.almoxarife_re}`,
            "id_empresa": `${this.solicitacaoItem.empresa_id}`,
            "origem":'lesser'
            };             
          const url = `${baseApiUrl}/jb/folha/funcionario/listagem`
          axios.post(url,corpo)
              .then(res => { this.almoxarifes = res.data })             
      },  

            async loadLider() { 
            let corpo = {                             
            "registro": `${this.solicitacaoItem.encarregado_re}`,
            "id_empresa": `${this.solicitacaoItem.empresa_id}`
            };             
          const url = `${baseApiUrl}/jb/folha/funcionario/listagem`
          axios.post(url,corpo)
              .then(res => { this.lideres = res.data })             
      },  


      async loadSolicitante() { 
            let corpo = {                             
            "registro": `${this.solicitacaoItem.solicitante_re}`,
            "id_empresa": `${this.solicitacaoItem.empresa_id}`
            };             
          const url = `${baseApiUrl}/jb/folha/funcionario/listagem`
          axios.post(url,corpo)
              .then(res => { this.solicitantes = res.data })             
      },  





      loadrequisicaoCorpo() { 
          let corpo = {    
              "empresa_id":  `${[this.user.id_empresa]}`,
              "filial_id": `${this.value_filial.map(f => f.id_filial_erp)}`,                                          
              };
          const url = `${baseApiUrl}/jb/estoque/solicitacao/listagem`
          axios.post(url,corpo).then(res => { 
            this.ResumorequisicaoCorpo = res.data             
          })
          .catch(showError)         
      },




      editrequisicaoCorpo(solicitacaoItem){                        /// 18/02/2024
            this.solicitacaoItem = { ...solicitacaoItem }
            this.loadEmpresaCad()
            this.loadFiliaisCad()
            this.loadVeiculo()
            this.loadSolicitante()
            this.loadAlmoxarife()
            this.loadMaterial()
      },








      async loadMaterial() { 
            let corpo = {                             
            "empresa_id": `${this.solicitacaoItem.empresa_id}`,
            "material": `${this.solicitacaoItem.material}`,
            "origem": 'FILTRO'
            };             
          const url = `${baseApiUrl}/jb/estoque/material/listagem`
          axios.post(url,corpo)
              .then(res => { this.materiais = res.data })             
      }, 


      /////////////////////////////////////////////////////////
        async postCorpo() { 
            let corpo = {                             
            "id": `${this.solicitacaoItem.id}`,
            "empresa_id": `${this.solicitacaoItem.empresa_id}`,
            "filial_id": `${this.solicitacaoItem.filial_id}`,
            "solicitacao_id": this.solicitacaoItem.id > 0 ?this.solicitacaoItem.solicitacao_id  : `${(this.nrorequisicao)}`,   
            "os_id": `${this.solicitacaoItem.ficha}`,
            //"carro_id": `${veiculos.map(at => at.id_veiculo).join(', ')}`,
            "operacao_id": 2,  // consumo
            "material_id": `${this.materiais['id_material']}`,
            "tipo_id": 2 , //= corretiva
            "status_id": this.solicitacaoItem.qtd_atendida != null ? 3 : null, //= corretiva            
            "qtd_solicitada": `${[this.solicitacaoItem.qtd_solicitada]}`,
            "qtd_atendida": `${[this.solicitacaoItem.qtd_atendida]}`,
            "observacao": `${[this.solicitacaoItem.observacao]}`,            
            "almoxarife_id": `${this.almoxarifes['id_funcionario_erp']}`,
            "requisitante_id": `${this.solicitantes['id_funcionario_erp']}`,
            "encarregado_id": `${this.lideres['id_funcionario_erp']}`,
            "venda_perdida": `${this.solicitacaoItem.venda_perdida}`,
            "funcionario_cad": `${this.user.id_funcionario_erp}`,
            "baixa": 'web',
            
            }; 
          const url = `${baseApiUrl}/jb/estoque/solicitacao/corpo`
          axios.post(url,corpo).then(() => {
            this.loadSolicitacoesItens(this.solicitacaoItem.solicitacao_id)            
            this.limparCorpo()               
              this.$toasted.global.defaultSuccess()                
                // this.loadrequisicaoMonitoramento()                                 carregamento dentro da requisicao selecionada
           })
           .catch(showError)
        },


        /////////atualizar encerramento da requisição 18/02/2024
        async encerrarCabecalho() { 
            let corpo = {  
            "id": this.nrorequisicao.length > 0 ?this.nrorequisicao  : `${(this.requisicao.id)}`,   
            "dt_cadastro": `${this.itemrequisicao.dt_cadastro}`,
            "id_funcionario_encerrou": `${this.user.id_funcionario}`,
            "lider_id": `${this.lideres['id_funcionario']}`,
            "requisitante_id": `${this.solicitantes['id_funcionario']}`,
            "status_id": 3,               
            }; 
          const url = `${baseApiUrl}/jb/estoque/requisicao/cadcabecalho`
            axios.post(url,corpo).then(() => {   
              this.loadSolicitacoes(),   // 19/02/2024
              this.loadrequisicaoCorpo()        
              //this.loadSolicitacoesItens()                   
              this.$toasted.global.defaultSuccess()  
              this.limparCorpo()                             

           })
           .catch(showError)
        },










      
      loadTipos() {
                    let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                            
            };
          const url = `${baseApiUrl}/jb/manutencao/requisicao/tipo`  
          axios.post(url,corpo).then(res => {
            this.tipos = res.data.map(tp => {              
              return { ... tp, value:  tp.id, tipo: tp.tipo, sos: tp.sos }              
            })            
          })          
      },

     

      loadLinhas() {
          let corpo = {    
              "id_empresa": `${this.requisicao.empresa_id}`,
              "id_filial": `${this.requisicao.filial_id}`                 
          };
          const url = `${baseApiUrl}/jb/planejamento/linha/cad`
          axios.post(url,corpo)
            .then(res => {
              this.linhas = res.data.map(lin => {                      
                return { ... lin, value: lin.id_linha, linha: lin.linha }  //// para pegar o valor tem que usar o ... atribuicao value
              })
            })
            .catch(showError)
      },
//              .then(res => { this.operador = res.data })    


      loadVeiculoSocorrista() {
        let corpo = {    
          "id_empresa": `${this.requisicao.empresa_id}`,
              "prefixo": `${this.requisicao.carro_socorrista}`                 
          };
          const url = `${baseApiUrl}/jb/manutencao/frota/veiculo`
          axios.post(url,corpo)
          .then(res => { this.socorrista_carro = res.data })                      
          .catch(showError)
      },

      loadVeiculoTrocado() {
        let corpo = {    
          "id_empresa": `${this.requisicao.empresa_id}`,
              "prefixo": `${this.requisicao.carro_trocado}`                 
          };
          const url = `${baseApiUrl}/jb/manutencao/frota/veiculo`
          axios.post(url,corpo)
           .then(res => { this.trocado_carro = res.data })                      
          .catch(showError)
      },


      loadCep() {      
                  axios.get('https://viacep.com.br/ws/'+ this.requisicao.cep+'/json/').then(res => { this.viacep = res.data })
      },

      
      async loadOperador() { 
            let corpo = {                             
            "registro": `${this.requisicao.operador}`,
            "id_empresa": `${this.requisicao.empresa_id}`
            };             
          const url = `${baseApiUrl}/jb/glo/escala/consulta`
          axios.post(url,corpo)
              .then(res => { this.operador = res.data })             
      },  

      async loadSocorrista() { 
            let corpo = {                             
            "registro": `${this.requisicao.socorrista}`,
            "id_empresa": `${this.requisicao.empresa_id}`
            };             
          const url = `${baseApiUrl}/jb/glo/escala/consulta`
          axios.post(url,corpo)
              .then(res => { this.socorristas = res.data })             
      },
      
      





      




      


























































    loadrequisicaoStatus() {
          const url = `${baseApiUrl}/jb/manutencao/requisicao/status`  
          axios.get(url).then(res => {
            this.statuss = res.data.map(st => {              
              return { ... st, value:  st.id_status, status: st.status }              
            })            
          })          
      },
      
      loadrequisicaoStatusJb() {
          const url = `${baseApiUrl}/jb/manutencao/requisicao/jbstatus`  
          axios.get(url).then(res => {
            this.situacaojb = res.data.map(jst => {              
              return { ... jst, value:  jst.id_jb_status, status: jst.jbstatus }              
            })            
          })          
      },


      loadNovoNrorequisicao() {
            const url = `${baseApiUrl}/jb/manutencao/requisicao/nro`
            axios.get(url).then(res => {
              this.nrorequisicao = res.data.rows[0].nextval
            })
      },
        
      async postCabecalho() { 
            let corpo = {             // {nrorequisicao.length > 0 ? nrorequisicao : requisicao.id
            "id": this.nrorequisicao.length > 0 ?this.nrorequisicao  : `${(this.requisicao.id)}`,   
            "id_funcionario_encerrou": `${this.user.id_funcionario}`,
            "status_id": 3,               
            //"empresa_id": `${this.requisicao.empresa_id}`,
            //"filial_id": `${this.requisicao.filial_id}`,
            //"carro_id": this.veiculos.length != 0  ? `${this.veiculos.map(v => v.id_veiculo)}`: this.requisicao.carro_id,            
            
            }; 
          const url = `${baseApiUrl}/jb/manutencao/requisicao/inscabecalho`
         axios.post(url,corpo).then(() => {
            //this.postCorpo()                         
           })
           .catch(showError)
      },

        

        


      


      ///////////////////////////////// 31/12/2022 as 20:17h
      editrequisicaoCabecalho(solicitacaoItem){
            this.solicitacaoItem = { ...solicitacaoItem }            
            //this.editrequisicaoCorpo()
            //this.loadSolicitacoesItens() 
            //this.loadFiliaisCad()
            //this.loadOperador()
            //this.loadTipos()
            //this.loadLinhas()
            //this.loadSocorrista()
            //this.loadVeiculo()
           // this.loadVeiculoSocorrista()
           // this.loadVeiculoTrocado()
           /// this.loadCep()
            
      },



      loadrequisicaoMonitoramento() { 
          let corpo = {    
               "empresa_id": `${[this.user.id_empresa]}`,             
               "id_empresa": `${[this.value_empresaf.map(e => e.id_empresa)]}`,                            
               "filial_id": `${[this.filiaisf.map(f => f.id_filial_erp)]}`,                                            
             "status_id": `${[this.value_status.map( s => s.id)]}`,        
               "tipo_id": `${[this.value_tipo.map(t => t.id)]}`                                   
                
                
          };
          const url = `${baseApiUrl}/jb/manutencao/requisicao/monitoramento`
          axios.post(url,corpo).then(res => { 
            this.requisicaos = res.data             
          })
          .catch(showError)         
      },

      

      
      reset() {
          this.postCorpo()
      },

      limparCorpo(){
        this.defeito =[]        
        this.executante=[]
       this.lider=[]        
       this.value_executante=''
        this.value_lider=''
        ///this.nrorequisicao=[]  // precisa limpar somente ao fechar ou quando cria-se uma nova ficha
      },

      novo(){
        this.requisicao = {}
        this.defeito = {}                
        this.
solicitacoeItens = {}
        //this.loadNovoNrorequisicao()
        //this.loadrequisicaoMonitoramento()
      }
       
    },
    
    mounted() {         
      this.loadEmpresas()      
      this.loadSolicitacoes()
      /*
      this.loadEmpresaCad() 
      this.loadSolicitacoes() //          // 15/02/2024
      this.loadrequisicaoCorpo()
      */
      //this.loadSolicitacoesItens()
      //this.loadrequisicaoStatus()
    },
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#placa{
    font-size: 0.7em;      
}

#modal-multi-requisicao___BV_modal_content_{
  background: rgb(227, 236, 227);
  /* border: 1px solid rgb(58, 20, 196) ; */
  border-radius: 8px;
  margin-bottom: 4px;  
}


#defeito-selecao{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196) ;
  border-radius: 8px;
  margin-bottom: 4px;  
}

#id-sos{  
  background: rgb(199, 222, 218);
  border: 1px solid red ;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-informado{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196) ;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-itemsolicitado{
  background: rgb(234, 239, 181);
  border: 1px solid rgb(12, 90, 2) ;
  border-radius: 8px;
  margin-bottom: 4px;  
  
}

#id-encerramento{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2) ;
  border-radius: 8px;
  margin-bottom: 4px;  
  
}

#requisicao-nro{
  color: rgb(240, 8, 8);
  font-size: 18px;
  text-align: center;
  
}



#garagem{  
  font-size: 12px;
  text-align: center;
  
}


.col-descricao {
    width: 300px; /* Largura desejada para a coluna 'Requisição' */
}




</style>